<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-24" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">

    <!-- Header Card -->
    <div class="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-6 text-white mb-6">
      <div class="flex items-center gap-3">
        <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="w-full">
          <h2 class="text-xl font-bold">تحویلی سفیر</h2>
          <p class="text-sm text-purple-50">مدیریت و بررسی تحویلی دستگاه‌ها</p>
        </div>
      </div>
    </div>

      
      <!-- Search Section -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        
        <!-- Branch Select -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">انتخاب شعبه</label>
          <div class="relative" ref="dropdownRef" @click.stop="dropdown_open = !dropdown_open">
            <div 
              class="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 cursor-pointer flex items-center justify-between"
              style="border: 1px solid #d1d5db !important;"
            >
              <span>{{ getSelectedBranchName() }}</span>
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            
            <!-- Dropdown Menu -->
            <div v-if="dropdown_open" class="absolute w-full mt-2 bg-white border border-gray-300 rounded-lg z-50 max-h-80 overflow-y-auto">
              <div 
                v-for="post in post_items" 
                :key="post.value"
                @click.stop="selected_branch = post.value; dropdown_open = false"
                class="px-4 py-3 hover:bg-gray-50 cursor-pointer text-sm"
              >
                {{ post.label }}
              </div>
            </div>
          </div>
        </div>

        <!-- Driver Search -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('searchDriver') }}</label>
          <div class="relative">
            <div class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              v-model="search"
              type="text"
              :placeholder="$t('search')"
              class="w-full pr-11 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              style="border: 1px solid #d1d5db !important;"
            />
          </div>
          
          <!-- Autocomplete Results -->
          <div v-if="entries.length > 0 && search" class="mt-2 bg-white border border-gray-200 rounded-lg max-h-60 overflow-y-auto">
            <div 
              v-for="entry in entries.filter(e => e.toLowerCase().includes(search.toLowerCase()))" 
              :key="entry"
              @click="model = entry"
              class="px-4 py-2 hover:bg-gray-50 cursor-pointer"
            >
              {{ entry }}
            </div>
          </div>
        </div>

      </div>

      <!-- Empty State -->
      <div v-if="request_items.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">در حال حاضر درخواستی برای نمایش وجود ندارد</p>
      </div>

      <!-- Request Cards -->
      <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div 
          v-for="item in request_items" 
          :key="item.Id"
          class="bg-white rounded-xl border border-gray-200 p-5 cursor-pointer hover:shadow-lg hover:border-purple-300 transition-all duration-200"
          @click="goToDetail(item)"
        >
          <!-- Request Header -->
          <div class="mb-3">
            <div class="flex items-center justify-between mb-2">
              <div class="flex-1 min-w-0">
                <h3 class="text-base font-bold text-gray-900 truncate">{{ item.RequestName }}</h3>
              </div>
              <div class="w-14 h-12 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0 mr-3">
                <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
            </div>
            <p class="text-sm text-gray-500">{{ item.RequestCode }}</p>
            <p class="text-xs text-gray-400 mt-1">{{ item.ReqReceivDate }}</p>
          </div>

          <!-- Status -->
          <div class="mb-3">
            <div class="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full">
              {{ item.StatusName }}
            </div>
          </div>

          <!-- Address -->
          <div class="mb-3 text-sm text-gray-600 flex items-center gap-2">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            {{ get_request_address(item) }}
          </div>

          <!-- Tags -->
          <div class="flex flex-wrap gap-2">
            <span 
              v-for="item_chip in item.PredefinedGlobal" 
              :key="item_chip.Text"
              class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200"
            >
              {{ item_chip.Text }}: {{ item_chip.Value }}
            </span>
            <span 
              v-for="item_chip in item.PredefinedChecked" 
              :key="item_chip.Text"
              class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200"
            >
              {{ item_chip.Text }}: {{ item_chip.Value }}
            </span>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        post_items: [],
        safir_items: [],
        selected_post: 0,
        selected_branch: 0,
        selected_safir_id: 0,
        request_items: [],

        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        dropdown_open: false,
      }
    },
watch: {
      selected_safir_id: function () {
        this.get_pre_requests()
      },
      selected_branch: function () {
        this.get_pre_requests()
      },
      model: function () {
        var self = this
        this.selected_safir_id = 0
        this.safir_items.forEach(function (number) {
          if (self.model == number.UserName) {
            self.selected_safir_id = number.Id
          }
          // this.entries.push(number.UserName);
        })
      },
      search (val) {
        this.get_safir_by_text(val)
      },

    },
mounted () {
      this.get_posts()
      
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(e.target)) {
          this.dropdown_open = false
        }
      })
    },

    methods: {

      goToDetail (item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if (item.IsFinalize == 1) {
          this.$router.push({ name: 'ViewRequest', params: { rec_id: item.Id } })
        } else {
          this.$router.push({ name: 'ViewPreRequest', params: { rec_id: item.Id } })
        }
      },
      get_safir_by_text (search_text) {
        this.isLoading = true

        var self = this
        const send_data = {
          Txt: search_text,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPeykerByText', send_data, { show_pros: false })
          .then(response => {
            // self.count = count
            self.safir_items = response.data.Payks
            self.safir_items.forEach(function (number) {
              // var obj = {label: number.BranchName, value: number.Id}
              self.entries.push(number.UserName)
            })
            // UserName
            self.isLoading = false
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_posts () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetBranches', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.branches.forEach(function (number) {
                var obj = { label: number.BranchName, value: number.Id }
                self.post_items.push(obj)
              })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_pre_requests () {
        this.request_items = []
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: this.selected_safir_id,
          BranchId: this.selected_branch,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserDevicesDelivery', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_items = response.data.requests
              // console.log("salam")
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        return address
      },
      getSelectedBranchName() {
        if (!this.selected_branch || this.selected_branch === 0) {
          return 'انتخاب کنید'
        }
        var found = this.post_items.find(function(post) {
          return post.value == this.selected_branch
        }.bind(this))
        return found ? found.label : 'انتخاب کنید'
      },

    }
  }
</script>
